import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSave,
  faSearch,
  faArrowUp,
  faArrowDown,
  faCloudUpload,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HollowLanding.css";
import "../../Shared/Searchbar.css";
import * as XLSX from "xlsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import CastingBedV from "../../Shared/CastingBedV";
import axios from "axios";

function HollowLanding() {
  const [excelData, setExcelData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [tableVisible, setTableVisible] = useState(true);
  const [filter, setFilter] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const numberOfColumns = 15; // Fixed to 15 columns

  //        API CODE FOR Form
  const [count, setCalculatedCount] = useState(0); // Initialize with a default value, e.g., 0

  // useEffect(() => {
  //   // Retrieve Excel data from localStorage when the component mounts
  //   const storedExcelData = localStorage.getItem('uploadedExcelData');
  //   if (storedExcelData) {
  //     const parsedData = JSON.parse(storedExcelData);
  //     setExcelData(parsedData);
  //     setFilteredData(parsedData); // Also update filteredData based on the retrieved data
  //   }
  // }, []);

  useEffect(() => {
    // Existing code to retrieve Excel data from localStorage when the component mounts
    const storedExcelData = localStorage.getItem("uploadedExcelData");
    if (storedExcelData) {
      const parsedData = JSON.parse(storedExcelData);
      setExcelData(parsedData);
      setFilteredData(parsedData); // Also update filteredData based on the retrieved data
    }

    // New code to clear Excel data from localStorage when the page is refreshed
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      localStorage.removeItem("uploadedExcelData");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const fetchBAQCount = async () => {
    const username = "manager"; // Replace with your username
    const password = "manager"; // Replace with your password
    const apiUrl = `https://77.92.189.102/PPGPrecastVertical/api/v1/BaqSvc/IIT_HC_Count(EPIC06)`; // Adjust the URL as needed
    try {
      const response = await fetch(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      const count = data.value[0].Calculated_CountTotalHC;
      setCalculatedCount(count); // Update the state
      console.log("Calculated Count:", count); // Debug: Log the calculated count
    } catch (error) {
      console.error(
        "There was a problem with your BAQ fetch operation:",
        error,
      );
    }
  };

  const handleRowClick = (rowIndex) => {
    if (!isEditing && excelData[rowIndex].some((cell) => cell !== "")) {
      const rowData = excelData[rowIndex];
      navigate(`/hollowform/${rowIndex}`, {
        state: { rowData, excelData, fileName, rowIndex, filteredData },
      });
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryString = event.target.result;
      const workbook = XLSX.read(binaryString, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Assuming processData correctly formats your data
      const processedData = processData(data); // Ensure this returns an array of rows
      setExcelData(processedData); // Store processed data in state

      // Ensure all rows have exactly 15 columns and filter out empty rows
      const dataWithoutHeader = data
        .slice(1)
        .map((row) => {
          if (row.length > numberOfColumns) {
            return row.slice(0, numberOfColumns);
          }
          while (row.length < numberOfColumns) {
            row.push(""); // Add empty cells if needed
          }
          return row;
        })
        .filter((row) => row.some((cell) => cell !== ""));

      setExcelData(dataWithoutHeader);
      setFilteredData(dataWithoutHeader); // Ensure filteredData is updated with new data
      setFileName(file.name);
      setFilter(""); // Clear any existing filters
      localStorage.setItem(
        "uploadedExcelData",
        JSON.stringify(dataWithoutHeader),
      );
      toast.success("Data Uploaded successfully");
    };

    reader.readAsBinaryString(file);

    fetchBAQCount();
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const handleAddRow = () => {
    const newRow = new Array(numberOfColumns).fill("");
    const newData = [...excelData, newRow];
    setExcelData(newData);
    setFilteredData(newData); // Update filteredData as well
  };

  const handleSave = () => {
    sendRowsToAPI();
    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "Slab ID",
        "Slab Code",
        "Description",
        "Design Width",
        "Design Length",
        "Design Height",
        "Slab Type",
        "Cross Sectional Area(mm²)",
        "Number of Top Strands",
        "Number of Bottom Strands",
        "Cover to Strand",
        "Concrete Grade(Mpa)",
        "Fire Rating(Hrs)",
        "Self Weight(Kg/M²)",
        "Self Weight Incl. Screed(Kg/M²)",
      ],
      ...excelData,
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, fileName); // Save changes to the original file
    toast.success("Data saved successfully");
  };

  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };

  const handleInputChange = (e, rowIndex, colIndex) => {
    setIsEditing(true);
    const newData = [...excelData];
    newData[rowIndex][colIndex] = e.target.value;
    setExcelData(newData);
    setFilteredData(newData); // Ensure filteredData is updated with new data
  };

  const handleInputBlur = () => {
    setIsEditing(false);
  };

  var incrementedKey = count + 1;

  // Function to send each row to the API via PATCH request
  async function sendRowsToAPI() {
    if (!excelData || excelData.length === 0) {
      console.error("No Excel data available.");
      return; // Prevent execution if no data
    }

    for (let i = 0; i < excelData.length; i++) {
      const row = excelData[i];
      const requestBody = prepareRequestBodyForPatchRequest(row);

      const username = "manager";
      const password = "manager";
      const apiKey = "AwDCwjhzpwrsjBYcJkspkfg5A1KNFSEqGupBR2BmCWrjk";

      try {
        const response = await axios.post(
          "https://77.92.189.102/PPGPrecastVertcal/api/v2/efx/PRECAST/IIT-HC/ExcellUpload",
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic " + btoa(`${username}:${password}`),
              // 'X-API-Key': apiKey,
            },
          },
        );
        console.log(`Row ${i + 1} sent.`);
      } catch (error) {
        console.error(`Failed row ${i + 1}:`, error);
      }
    }
    toast.dark(`Cycle ID : ${incrementedKey}`);
  }

  // Example function to prepare the request body for a PATCH request
  function prepareRequestBodyForPatchRequest(row) {
    // Map each column in the row to the corresponding field in the API request
    return {
      KEY1: incrementedKey, // Assuming the first column is 'KEY1'
      slabID: row[0], // Assuming the second column is 'slabID'
      slabCode: row[1], // Assuming the third column is 'slabCode'
      Desc: row[2], // Assuming the fourth column is 'Desc'
      width: parseFloat(row[3]), // Assuming the fifth column is 'width'
      length: parseFloat(row[4]), // Assuming the sixth column is 'length'
      height: parseFloat(row[5]), // Assuming the seventh column is 'height'
      type: row[6], // Assuming the eighth column is 'type'
      crossArea: parseFloat(row[7]), // Assuming the ninth column is 'crossArea'
      topStrand: parseInt(row[8]), // Assuming the tenth column is 'topStrand'
      BottomStrand: parseInt(row[9]), // Assuming the eleventh column is 'BottomStrand'
      Cover: parseFloat(row[10]), // Assuming the twelfth column is 'Cover'
      ConcreteGrade: parseInt(row[11]), // Assuming the thirteenth column is 'ConcreteGrade'
      FireRating: parseInt(row[12]), // Assuming the fourteenth column is 'FireRating'
      Selfweight: parseFloat(row[13]), // Assuming the fifteenth column is 'Selfweight'
      Screed: parseFloat(row[14]), // Assuming the sixteenth column is 'Screed'
    };
  }

  function processData(data) {
    // Example processing logic, adjust as necessary
    return data; // Directly return the data if no processing is needed
  }

  return (
    <div className="card hollowtable">
      <ToastContainer />
      <div className="card-header">
        {/* <button type='button' className='toggle-table-icon-hcl' onClick={toggleTableVisibility}>
          <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
        </button> */}
        {/* <div className='panelTitlDiv'>
          <h2 className='panel-title-Hollow'>HC List</h2>
        </div> */}
        <div className="Element-id-container-hollow">
          <input
            type="text"
            placeholder=" Slab ID"
            className="Elementidinput-hollow"
            onChange={handleFilterChange}
          />
        </div>
        <div className="ctrl-btns-hollowland">
          <input
            type="file"
            style={{ display: "none" }}
            ref={fileInputRef}
            onChange={handleFileUpload}
            accept=".xlsx,.xls"
          />
          <button
            className="btn"
            id="upload"
            onClick={() => fileInputRef.current.click()}
          >
            <FontAwesomeIcon icon={faCloudUpload} />
          </button>
          <Tooltip anchorSelect="#upload" content="Load File" place="bottom" />
          <button className="btn" id="add" onClick={handleAddRow}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
          <Tooltip anchorSelect="#add" content="Add" place="bottom" />
          <button className="btn" id="save" onClick={handleSave}>
            <FontAwesomeIcon icon={faSave} />
          </button>
          <Tooltip anchorSelect="#save" content="Save" place="bottom" />
        </div>
      </div>
      {tableVisible && (
        <>
          <div className="card-body">
            <div className="table-responsive">
              <div className="scrollable-table-body table-bordered">
                <table className="table table-bordered-hollow">
                  <thead className="table-primary">
                    <tr className="bg-primary text-white">
                      <th>Slab ID</th>
                      <th>Slab Code</th>
                      <th>Description</th>
                      <th>Design Width</th>
                      <th>Design Length</th>
                      <th>Design Height</th>
                      <th>Slab Type</th>
                      <th>Cross Sectional Area(mm²)</th>
                      <th>Number of Top Strands</th>
                      <th>Number of Bottom Strands</th>
                      <th>Cover to Strand</th>
                      <th>Concrete Grade(Mpa)</th>
                      <th>Fire Rating(Hrs)</th>
                      <th>Self Weight(Kg/M²)</th>
                      <th>Self Weight Incl. Screed(Kg/M²)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData &&
                      filteredData.map((row, rowIndex) => (
                        <tr
                          key={rowIndex}
                          onClick={() => handleRowClick(rowIndex)}
                        >
                          {row.map((cell, colIndex) => (
                            <td key={colIndex}>
                              <input
                                type="text"
                                className={
                                  colIndex === 0
                                    ? "UpdateInput blue-hyper"
                                    : "UpdateInput"
                                }
                                value={cell}
                                onChange={(e) =>
                                  handleInputChange(e, rowIndex, colIndex)
                                }
                                onBlur={handleInputBlur}
                                onFocus={() => setIsEditing(true)}
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
      {filteredData.length > 0 && <CastingBedV elements={filteredData} />}
    </div>
  );
}

export default HollowLanding;
